import React from "react";

/**
 * StatusRow - Table row for displaying boolean status values
 *
 * @param {string} label - Label for the status
 * @param {boolean} value - Boolean value to display
 * @param {boolean} invertColors - If true, false=green and true=red (default: false)
 */
function StatusRow({ label, value, invertColors = false }) {
  const isPositive = invertColors ? !value : value;
  const icon = isPositive ? "\u2713" : "\u2717";
  const className = isPositive ? "text-success" : "text-danger";

  return (
    <tr>
      <td>{label}</td>
      <td className={className}>
        <strong>{icon}</strong> {isPositive ? "Yes" : "No"}
      </td>
    </tr>
  );
}

export default StatusRow;
